/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_New_Sources_EmptyInputs */

const vi_scl_new_sources_empty = /** @type {(inputs: Scl_New_Sources_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có lô nguồn — bấm "Thêm lô nguồn"`)
};

/**

* @param {Scl_New_Sources_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_new_sources_empty = /** @type {((inputs?: Scl_New_Sources_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_New_Sources_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_new_sources_empty(inputs)
});